import { render, staticRenderFns } from "./personal_transport.vue?vue&type=template&id=2f4a5781&scoped=true"
import script from "./personal_transport.vue?vue&type=script&lang=js"
export * from "./personal_transport.vue?vue&type=script&lang=js"
import style0 from "./personal_transport.vue?vue&type=style&index=0&id=2f4a5781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a5781",
  null
  
)

export default component.exports